/**
 * Whether the app is running on the production domain (fluxabee.com).
 *
 * Two contexts:
 *   1. Browser runtime - authoritative via `window.location.hostname`.
 *   2. SSG build (no `window`) - falls back to `VITE_PUBLIC_SITE_URL`
 *      injected at build time so prerendered HTML emits `index, follow`
 *      on prod builds (and `noindex` on dev/preview builds).
 */
const PUBLIC_SITE_URL = import.meta.env.VITE_PUBLIC_SITE_URL as
  | string
  | undefined;

const buildTimeIsProduction =
  typeof PUBLIC_SITE_URL === "string" &&
  /\/\/(www\.)?fluxabee\.com(\/|$)/.test(PUBLIC_SITE_URL);

const isPreview = import.meta.env.VITE_SITE_PREVIEW === "true";

export const isProductionDomain: boolean = !isPreview && (
  typeof window !== "undefined"
    ? window.location.hostname === "fluxabee.com" ||
      window.location.hostname === "www.fluxabee.com"
    : buildTimeIsProduction
);
